import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function WaitingOnClientProgressionProActions({
  vm,
}: Props) {
  return (
    <>
      {vm.containsExtensionRejected && (
        <CardContent>
          <Button
            type="secondary"
            size="wide-slim"
            onClick={() => vm.viewExtensionDocumentCreationModal()}
            dataTest="job-progression-upload-rejection-confirmation-button"
          >
            Upload Rejection Confirmation
          </Button>
        </CardContent>
      )}
    </>
  )
})
